import React from 'react';
import { format } from 'date-fns';

import { LatencyCard, fmtMs } from './LatencyCard';
import type { ToolCallsResponse } from '../../../../../api';

type Props = {
  data?: ToolCallsResponse | null;
  loading?: boolean;
};

export const ToolCallsTable: React.FC<Props> = ({ data, loading }) => {
  const items = data?.items ?? [];

  return (
    <LatencyCard
      title="Tool calls"
      subtitle="most recent tool/function calls"
      loading={loading}
      isEmpty={items.length === 0}
    >
      <div className="h-full overflow-auto">
        <table className="w-full text-small text-left">
          <thead className="text-secondary sticky top-0 bg-white">
            <tr className="border-b">
              <th className="py-2 pr-3 font-medium">Time</th>
              <th className="py-2 pr-3 font-medium">Tool</th>
              <th className="py-2 pr-3 font-medium">Type</th>
              <th className="py-2 pr-3 font-medium text-right">Exec</th>
              <th className="py-2 pr-0 font-medium text-right">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={`${item.timestamp}-${item.tool_name}-${index}`}
                className="border-b last:border-0"
              >
                <td className="py-2 pr-3 whitespace-nowrap">
                  {format(new Date(item.timestamp), 'MM-dd HH:mm:ss')}
                </td>
                <td className="py-2 pr-3">{item.tool_name}</td>
                <td className="py-2 pr-3">{item.tool_type || '—'}</td>
                <td className="py-2 pr-3 text-right">
                  {fmtMs(item.execution_time_ms)}
                </td>
                <td className="py-2 pr-0 text-right">
                  {item.success === null ? (
                    '—'
                  ) : item.success ? (
                    <span className="text-green-600 font-medium">ok</span>
                  ) : (
                    <span className="text-red-600 font-medium">
                      {item.error_type || 'error'}
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </LatencyCard>
  );
};
